import { createFileRoute } from '@tanstack/react-router'
import EditUser from 'Administration/components/access/EditUser'

import AdministrationPage from '../../-administrationPage'
import { Guard, adminClaims } from '../../-guard'

export const Route = createFileRoute('/administration/users/$id')({
    component: () => (
        <Guard claims={adminClaims}>
            <AdministrationPage>
                <EditUser />
            </AdministrationPage>
        </Guard>
    ),
})
